import configureStore from "./configureStore";
export const store = configureStore();
